import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme, type ThemeChoice } from '../hooks/useTheme';
import { AutoThemeIcon, MoonIcon, SunIcon } from './Icons';

const OPTIONS: Array<{ value: ThemeChoice; labelKey: 'theme.auto' | 'theme.light' | 'theme.dark'; icon: ComponentType<{ size?: number }> }> = [
  { value: 'auto', labelKey: 'theme.auto', icon: AutoThemeIcon },
  { value: 'light', labelKey: 'theme.light', icon: SunIcon },
  { value: 'dark', labelKey: 'theme.dark', icon: MoonIcon },
];


export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const { choice, setChoice } = useTheme();
  return (
    <div className={`segmented theme-toggle${compact ? ' theme-toggle--compact' : ''}`} role="radiogroup" aria-label={t('theme.label')}>
      {OPTIONS.map(({ value, labelKey, icon: Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={choice === value}
          aria-label={compact ? t('theme.option', { label: t(labelKey) }) : undefined}
          title={compact ? t(labelKey) : undefined}
          onClick={() => setChoice(value)}
        >
          <Icon size={18} />
          {!compact && <span>{t(labelKey)}</span>}
        </button>
      ))}
    </div>
  );
}
